// extracted by mini-css-extract-plugin
module.exports = {"fixedBottomContainer":"product-detail-challenge-tooltip_fixedBottomContainer__kCXva","button":"product-detail-challenge-tooltip_button__3Gzhn"};